/** API base URL (trailing slash stripped). Defaults to the local worker. */
export const API_URL = (import.meta.env.VITE_API_URL ?? 'http://localhost:8787').replace(/\/$/, '');
